import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Stack,
  CircularProgress,
  Alert,
} from "@mui/material";
import { RatIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import useApiEp from "../../hooks/useApiEp";
import { API_ENDPOINT } from "../../utils/constants";
import { getHeader } from "../../utils/util";
import BackBtn from "../../widgets/BackBtn";

const AccountSetLimit = () => {
  const { id } = useParams();
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/root/get-account/${id}`
  );

  const [phoneNumberLimit, setPhoneNumberLimit] = useState("");
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  // Pre-populate when data loads
  useEffect(() => {
    if (data?.phoneNumberLimit !== undefined) {
      setPhoneNumberLimit(data.phoneNumberLimit);
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);
    try {
      await axios.post(
        `${API_ENDPOINT}/root/update-account-limit`,
        {
          accountId: id,
          phoneNumberLimit: Number(phoneNumberLimit),
        },
        getHeader()
      );
      setSuccess(true);
      refetch();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  if (isLoading) {
    return (
      <Container sx={{ mt: 6, textAlign: "center" }}>
        <CircularProgress />
      </Container>
    );
  }

  if (isError) {
    return (
      <Container sx={{ mt: 6 }}>
        <Alert severity="error">
          {error?.message || "Failed to load account details"}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <BackBtn />
      <Card elevation={3}>
        <CardContent>
          <Stack spacing={3}>
            <Stack direction="row" spacing={1} alignItems="center">
              <RatIcon size={20} />
              <Typography variant="h6" fontWeight={600}>
                Set Phone Number Limit
              </Typography>
            </Stack>

            <Typography variant="body2" color="text.secondary">
              Configure the maximum number of phone numbers allowed for this
              account.
            </Typography>

            {success && (
              <Alert severity="success">
                Phone number limit updated successfully
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  label="Phone Number Limit"
                  type="number"
                  fullWidth
                  required
                  inputProps={{ min: 0 }}
                  value={phoneNumberLimit}
                  onChange={(e) => setPhoneNumberLimit(e.target.value)}
                  helperText="Enter the maximum allowed phone numbers"
                />

                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={saving}
                >
                  {saving ? "Saving..." : "Save Limit"}
                </Button>
              </Stack>
            </form>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AccountSetLimit;
